"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _core = require("@material-ui/core");
var _utils = require("./utils");
const useStyles = exports.useStyles = (0, _core.makeStyles)(theme => ({
  bar: {
    height: '2px',
    flexGrow: 1
  },
  [`bar-${_utils.STRENGTH.NONE}`]: {
    backgroundColor: theme.palette.grey[300]
  },
  [`text-${_utils.STRENGTH.NONE}`]: {
    color: theme.palette.primary.main
  },
  [`bar-${_utils.STRENGTH.WEAK}`]: {
    backgroundColor: theme.palette.error.main
  },
  [`text-${_utils.STRENGTH.WEAK}`]: {
    color: theme.palette.error.main
  },
  [`bar-${_utils.STRENGTH.ACCEPTED}`]: {
    backgroundColor: theme.palette.warning.main
  },
  [`text-${_utils.STRENGTH.ACCEPTED}`]: {
    color: theme.palette.warning.main
  },
  [`bar-${_utils.STRENGTH.STRONG}`]: {
    backgroundColor: theme.palette.success.main
  },
  [`text-${_utils.STRENGTH.STRONG}`]: {
    color: theme.palette.success.main
  },
  [`bar-${_utils.STRENGTH.PERFECT}`]: {
    backgroundColor: theme.palette.success.main
  },
  [`text-${_utils.STRENGTH.PERFECT}`]: {
    color: theme.palette.success.main
  }
}));